import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToggleService {
  private _isOn = signal(null);
  isOn = this._isOn; // Expose signal for reading in consumers

  setOn(value: boolean) {
    this._isOn.set(value);
  }

  toggle() {
    this._isOn.update(v => !v);
  }
}
